import React from "react"
import PropTypes from "prop-types"

class Delegate extends React.Component {
  static propTypes = {
    component: PropTypes.func.isRequired,
  }

  state = {}

  render() {
    const { component: Component, ...rest } = this.props
    const props = Object.assign({}, rest, this.state)
    if (props.show) {
      return <Component {...props} onSubmit={this.handleSubmit} onClose={this.close} onCancel={this.cancel} />
    } else {
      return null
    }
  }

  show(props) {
    this.setState({
      show: true,
      ...props,
    })
  }

  close = () => {
    this.setState(
      {
        show: false,
      },
      () => {
        this.state.onClose && this.state.onClose()
      }
    )
  }

  cancel = () => {
    this.setState(
      {
        show: false,
      },
      () => {
        this.state.onCancel && this.state.onCancel()
      }
    )
  }

  handleSubmit = (...args) => {
    this.setState(
      {
        show: false,
      },
      () => {
        this.state.onSubmit && this.state.onSubmit(...args)
      }
    )
  }
}

export default Delegate
